import EntryLanguageFooter from "../../components/EntryLanguageFooter";
import React, { useContext } from "react";
import EntryBrandingContext from "./entryBrandingContext";
import { Link } from "@reach/router";
import AppleButton from "../../components/AppleButton";
import EmailLoginButton from "../../components/EmailLoginButton";
import FacebookButton from "../../components/FacebookButton";
import GoogleButton from "../../components/GoogleButton";
import SonicboxLogoPNG from "../../images/sonicbox-logo.png";
import { T } from "../../hooks/useLanguage";

export default function EntryLoginGate({ radioName = null }) {
  const { active } = useContext(EntryBrandingContext);
  return (
    <div className="container index-page">
      <img src={SonicboxLogoPNG} alt="Sonicbox logo" className="page-logo" />
      {!active && <p><T>home.welcome</T></p>}
      <h1>{active ? <T>entry.signInTitle</T> : radioName ? radioName : <T>home.title</T>}</h1>
      {active && <p className="entry-login__description"><T>entry.signInDescription</T></p>}
      <GoogleButton />
      <AppleButton />
      <FacebookButton />
      <EmailLoginButton className={active ? "success" : undefined} />
      <p>
        <Link to="/login" className={active ? "entry-login__password" : undefined}>
          <T>{active ? "entry.passwordLogin" : "home.mustlogin"}</T>
        </Link>
      </p>
      <EntryLanguageFooter />
    </div>
  );
}
